
import { Button } from "@/components/ui/button";
import { Zap, MessageCircle, Flag } from "lucide-react";

interface ProfileActionButtonsProps {
  onBuzzz: () => void;
  onMessage: () => void;
  onReport: () => void;
  isBuzzing: boolean;
}

const ProfileActionButtons = ({
  onBuzzz,
  onMessage,
  onReport,
  isBuzzing
}: ProfileActionButtonsProps) => {
  return (
    <div className="relative z-50 bg-white p-4 border-t border-gray-200">
      <div className="flex justify-center space-x-6">
        <Button
          variant="outline"
          size="lg"
          onClick={onReport}
          className="w-14 h-14 rounded-full border-2 border-gray-300 hover:border-red-400 hover:bg-red-50 text-gray-600 hover:text-red-600 bg-white shadow-lg"
        >
          <Flag className="w-6 h-6" />
        </Button>
        
        <Button
          size="lg"
          onClick={onMessage}
          className="w-16 h-16 rounded-full bg-blue-500 hover:bg-blue-600 text-white shadow-lg border-2 border-blue-600 hover:border-blue-700 transform hover:scale-105 transition-all duration-200"
        >
          <MessageCircle className="w-7 h-7" />
        </Button>
        
        <Button
          variant="outline"
          size="lg"
          onClick={onBuzzz}
          disabled={isBuzzing}
          className="w-14 h-14 rounded-full border-2 border-neon-red/30 hover:border-neon-red/40 text-neon-red hover:text-neon-red bg-white hover:bg-neon-red/10 shadow-lg disabled:opacity-50"
        >
          <Zap className="w-6 h-6" />
        </Button>
      </div>
    </div>
  );
};

export default ProfileActionButtons;
